import React from 'react';
import { string, bool, array, func } from 'prop-types';
import styled, { css } from 'styled-components';
import { Text, IconContainer, Icon, Column } from '../../../../../../../components/common';

const TableContainerWrapper = styled.div`
  height: 100%;
  display: flex;
  width: 100%;
  ${({ isMobile }) => isMobile && css`
    max-height: calc(100vh - 198px);
    th {
        position: sticky;
        top: 0;
        background-color: #ffffff;
        z-index: 1;
    }
  `}
`;

const HeaderContainer = styled.div`
    background-color: #FFFFFF;
    border-radius: 12px;
    min-width: 100%;
    width: 100% ;
    height: 100%;
    margin-bottom: 8px;
tr {
    text-align:center;
    width: 100%;
    display: flex;
    justify-content: space-between;
}
th {
    border-bottom: 0px solid white;
    align-items: center;
    width: 100%;
    text-align: center;
}
`

const AuditStatusTable = ({
    title,
    data,
    headers,
    footer = [],
    className,
    renderItem,
    renderFooter,
    renderHeader,
    fetching,
    tableProps,
    isMobile,
}) => {
    return (
        <TableContainerWrapper isMobile={isMobile}>
            {!data.length ? (
                <Column align='center' justify='center' mB={20}>
                    <IconContainer margin={20}>
                        <Icon name='cross' size={30} color='#ffffff' />
                    </IconContainer>
                    <Text size={14} text='No se han encontrado productos.' />
                </Column>
            ) : (
                <table {...tableProps} style={!isMobile ? {
                    width: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    tableLayout: 'fixed',
                    justifyContent: "space-between",
                    alignItems: 'stretch',
                    borderCollapse: 'collapse'
                } : {}}>
                    <thead>
                        {!isMobile ? (<HeaderContainer>

                            <tr className="group-header">
                                <th
                                    style={{
                                        margin: 0,
                                        padding: "4px",
                                        width: "17%",
                                        textAlign: 'center',
                                        fontWeight: 400,
                                        fontSize: 12,
                                        borderRight: '1px solid #E0E0E0',
                                        borderBottom: '1px solid #E0E0E0',
                                    }}
                                    colSpan={2}
                                >
                                    Producto
                                </th>
                                <th
                                    style={{
                                        margin: 0,
                                        padding: "4px",
                                        width: "25%",
                                        textAlign: 'center',
                                        fontSize: 12,
                                        fontWeight: 400,
                                        borderRight: '1px solid #E0E0E0',
                                        borderBottom: '1px solid #E0E0E0',
                                    }}
                                    colSpan={3}
                                >
                                    Cantidad
                                </th>
                                <th
                                    style={{
                                        margin: 0,
                                        padding: "4px",
                                        width: "33%",
                                        textAlign: 'center',
                                        fontSize: 12,
                                        fontWeight: 400,
                                        borderRight: '1px solid #E0E0E0',
                                        borderBottom: '1px solid #E0E0E0',
                                    }}
                                    colSpan={4}
                                >
                                    Precio
                                </th>
                                <th
                                    style={{
                                        margin: 0,
                                        padding: "4px",
                                        textAlign: 'center',
                                        width: "25%",
                                        fontSize: 12,
                                        fontWeight: 400,
                                        borderBottom: '1px solid #E0E0E0',
                                    }}
                                    colSpan={3}
                                >
                                    Validación
                                </th>
                            </tr>
                            <tr style={{alignItems:'center'}}>
                                {headers.map(renderHeader)}
                            </tr>
                        </HeaderContainer>
                        ) :
                            (<tr>
                                {headers.map(renderHeader)}
                            </tr>)
                        }
                    </thead>
                    <tfoot>
                        <tr>{(footer || headers).map(renderFooter)}</tr>
                    </tfoot>
                    <tbody style={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                        {Object.values(data).map(renderItem)}
                    </tbody>
                </table>
            )
            }
        </TableContainerWrapper >
    );
};

AuditStatusTable.propTypes = {
    className: string,
    data: array,
    fetching: bool,
    title: string,
    renderHeader: func,
    renderFooter: func,
    renderItem: func,
    headers: array,
    footer: array,
    isMobile: bool
};

AuditStatusTable.defaultProps = {
    title: 'table',
    headers: [],
    footer: [],
    items: [],
    renderHeader: (header, key) => (<th className='header' key={`th-${key}`} >{header}</th>),
    renderFooter: (footerItem, key) => (<th key={`tf-${key}`}>{footerItem}</th>),
    renderItem: () => ([]),
    isMobile: false
};

export default AuditStatusTable;
